<template>
    <div id="listing_gallery ">

        <!-- error dialog displays any potential errors -->
        <div v-if="errorDialog" class="bg-red-500 px-3 mx-3 py-2 text-white" v-model="errorDialog">
            {{errorText}}
        </div>

        <div class="flex flex-wrap">

            <!-- This is important for EDIT forms - to add current images back into the gallery -->
            <div class="relative w-1/2 md:w-1/3 px-3 my-6"  v-for="(image, int) in currentImages" :key="int">
                <img :src="image.url" class="preview w-full" style=""/>

                <div class="absolute top-0 right-0 mt-3 mr-6">
                    <div class="bg-white bg-opacity-70 p-1">
                       <span class="cursor-pointer" @click="deleteCurrentImage(int, image)">
                            <svg class="w-5 h-5 text-smarta-pink-500 hover:text-smarta-pink-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                        </span>
                    </div>
                </div>
            </div>


            <!-- This is important for CREATE + EDIT forms - to add NEW imagges into the gallery -->
            <div class="relative w-1/2 md:w-1/3 px-3 my-6"  v-for="(image, key) in images" :key="key">

                <img :src="image.src" class="preview w-full" style=""/>

                <span class="font-body text-sm">{{ image.file.name }}</span>

                <div class="absolute top-0 right-0 mt-3 mr-6">
                    <div class="bg-white bg-opacity-70 p-1">
                       <span class="cursor-pointer" @click="deleteImage(key)">
                            <svg class="w-5 h-5 text-smarta-pink-500 hover:text-smarta-pink-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                        </span>
                    </div>
                </div>

            </div>

            <div v-if="showUploadBtn" class="w-1/2 md:w-1/3 px-3 my-6" >
                    <div class="flex border-2 border-smarta-pink-500 justify-center items-center border-dashed cursor-pointer hover:text-smarta-blue-300 hover:border-smarta-pink-300">
                        <label class="h-48 w-full justify-center flex file_select flex flew-row items-center select_button text-sm py-2 px-5 font-bold uppercase cursor-pointer transition duration-500 ease-in-out">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                            <span class="ml-2">Upload</span>
                            <input type="file" class="" multiple accept="image/jpeg" @change="uploadImage"/>
                        </label>
                    </div>
            </div>

        </div>

    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.file_select > .select_button {

    color: white;
    border-radius: 0;

    text-align: center;
    font-weight: bold;
}

/* Don't forget to hide the original file input! */
.file_select > input[type="file"] {
    display: none;
}
</style>

<script>
export default {
    /** Prop value will allows us to retrieve currently set and populated data **/
    props: ['value'],
    data() {
        return {
            currentImages: this.value,
            images: [],
            currentImagesToDelete: [],
            maxSize: 1024,
            maxUploads: 9,
            errorDialog: null,
            errorText: '',
            showUploadBtn: true
        }
    },
    created() {

        /** Firstly - let's count the length of the images array - new forms will be empty **/
        var length = this.images.length; // user defined length

        /** Simple Iterator to push a new validation object for each location  **/
        if(length >= this.maxUploads) {
            this.showUploadBtn = false;
        }

    },
    methods: {
        uploadImage(e) {

            let selectedFiles = e.target.files;

            //First lets do a check to see if the user has batch selected more than 9 files - if so return early and error
            if (selectedFiles.length > this.maxUploads){
                this.errorDialog = true
                this.errorText = 'Can only upload 9 images'
                return false;
            }

            //Once we have checked we can upload X amount images and it's a value request - lets process it through the loop
            for (let i = 0; i < selectedFiles.length; i++) {

                let img = {
                    src: URL.createObjectURL(selectedFiles[i]),
                    file: selectedFiles[i],
                }

                let size = img.file.size / this.maxSize / this.maxSize

                if (size>1) {
                    // check whether the size is greater than the size limit
                    this.errorDialog = true
                    this.errorText = 'Your file is too big! Please select an image under 1MB'
                }else if(!img.file.type.match('image.*')){
                    // check whether the file is actually an image type
                    this.errorDialog = true
                    this.errorText = 'Please choose an image file - PNG / JPG accepted'
                }else if(this.images.length > (this.maxUploads - 1)){
                    // check whether current file exceeds our max limit not the minus 1 as we 0 index arrays!!
                    this.errorDialog = true
                    this.showUploadBtn = false;
                    this.errorText = 'Sorry, you have reach your maximum upload limit of 9 images'
                }
                else{
                    this.errorDialog = false
                    this.images.push(img);
                }

            }

            this.$emit('updateGallery', this.images)
        },
        /** Delete the specific object from the array of locations - pass iin the key of the specific object as passed
         * through in the click event **/
        deleteImage(key){

            this.$buefy.dialog.confirm({
                title: 'Confirm delete',
                message: 'Are you sure you want to delete this image?',
                onConfirm: () => {
                    /** Find the corresponding key in the images array and remove it **/
                    this.images.splice(key,1);

                    flash('Image removed', 'danger');
                }
            })


        },
        /** Delete images for CURRENT images (FOR EDIT FORM ONLY) **/
        deleteCurrentImage(int, image){
            this.$buefy.dialog.confirm({
                title: 'Confirm delete',
                message: 'Are you sure you want to delete this image?',
                onConfirm: () => {
                    /** Find the corresponding key in the images array and remove it **/
                    this.currentImages.splice(int,1);
                    this.currentImagesToDelete.push(image.name);
                    this.$emit('removeImages', this.currentImagesToDelete)
                    flash('Image removed', 'danger');
                }
            })
        }

    }
}
</script>
